<div class="flex">
  <div class="data">{{data}}</div>
  
</div>
